var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch2 = function SvgSearch2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 128,
    height: 128
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.8 217.8c-4.6 4.6-12.2 4.6-17 0l-25.4-25.4c-4.6-4.6-4.6-12.2 0-17 4.6-4.6 12.2-4.6 17 0l25.4 25.4c4.6 4.8 4.6 12.4 0 17zM55.07 55.178c-27.337 27.337-27.336 71.659.001 98.995 27.338 27.336 71.659 27.335 98.995-.002 27.337-27.337 27.336-71.659-.001-98.995-27.338-27.336-71.66-27.335-98.995.002z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.07 55.178c-27.337 27.337-27.336 71.659.001 98.995 27.338 27.336 71.659 27.335 98.995-.002 27.337-27.337 27.336-71.659-.001-98.995-27.338-27.336-71.66-27.335-98.995.002z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.6 168.6c-3.4 0-6-2.6-6-6s2.6-6 6-6c13.8 0 27-5.4 36.8-15.2 12.8-12.8 18-31 13.8-48.8-.8-3.2 1.2-6.4 4.4-7.2 3.2-.8 6.4 1.2 7.2 4.4 5.2 21.8-1 44.4-16.8 60.2-12.2 12-28.2 18.6-45.4 18.6zM146 70c-1.6 0-3-.6-4.2-1.8l-.4-.2c-2.4-2.4-2.4-6.2 0-8.4 2.4-2.4 6.2-2.4 8.4 0l.4.4c2.4 2.4 2.4 6.2 0 8.4-1.2 1-2.6 1.6-4.2 1.6z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.6 180.6c-19.4 0-39-7.4-53.8-22.2-29.6-29.6-29.6-77.8 0-107.4 29.6-29.6 77.8-29.6 107.4 0 29.8 29.6 29.8 77.8.2 107.4-14.8 14.8-34.2 22.2-53.8 22.2zm0-139.8c-16.4 0-32.8 6.2-45.2 18.8-25 25-25 65.6 0 90.6 25 24.6 65.6 24.6 90.6-.2 25-25 25-65.6 0-90.6-12.6-12.4-29-18.6-45.4-18.6zM222 196.6l-25.4-25.4c-3.4-3.4-8-5.2-12.8-5.2-2.8 0-5.4.6-7.8 1.8l-5-5c-2.4-2.4-6.2-2.4-8.4 0-2.4 2.4-2.4 6.2 0 8.4l5 5c-1.2 2.4-1.8 5-1.8 7.8 0 4.8 1.8 9.4 5.2 12.8l25.6 25.2c3.6 3.6 8.2 5.2 12.8 5.2 4.6 0 9.2-1.8 12.8-5.2 6.8-7 6.8-18.4-.2-25.4zm-8.4 17c-2.4 2.4-6.2 2.4-8.4 0l-25.6-25.4c-1.2-1.2-1.8-2.6-1.8-4.2s.6-3.2 1.8-4.2c1.2-1.2 2.6-1.8 4.2-1.8s3.2.6 4.2 1.8l25.4 25.4c2.6 2.2 2.6 6 .2 8.4z",
    fill: "#444b54"
  }))));
};
export default SvgSearch2;